import { ContextService } from '../../services/context_service';
import { DataService } from '../../services/data_service';
import { Document } from '@react-pdf/renderer';
import { EntwicklungsplanSpalte } from './elemente/EntwicklungsplanSpalte';
import { EntwicklungsplanSpalteMass2 } from './elemente/EntwicklungsplanSpalteMass2';
import formStyle from '../../core/forms/style/WForm.less';
import { GetLayoutStyle } from './pdf/layout';
import { getPdfData } from './pdf/EntwicklungsplanPdf';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import { pdf } from '@react-pdf/renderer';
import * as React from 'react';
import { renderText } from '../dateneingabe/assistent/assistent_helpers';
import style from './Entwicklungsplan.less';
import { svgToPng } from '../helper';
import { TriggerService } from '../../core/trigger/trigger_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { WArchivIcon } from '../../core/elements/WArchivIcon';
import { WSpinner } from '../../core/elements/spinner/WSpinner';
import { ZusatztoolsEntwicklungsfahrplanSpaltenEditor } from './ZusatztoolsEntwicklungsfahrplanSpaltenEditor';

interface ZusatztoolsEntwicklungsfahrplanProps extends React.ClassAttributes<any> {
    callbackPages?: (pageNumber: number, totalPages: number) => void;
    data: any;
    setJSXdirect?: (content: JSX.Element) => void;
}

interface ZusatztoolsEntwicklungsfahrplanState {
    loading: boolean;
    modus: number;
    pdfLink: string;
    spalten_anzahl: number;
    spalten_auswahl: number;
    spalten_daten: any[];
    tid_loaded: number;
    stand: number;
}

export class ZusatztoolsEntwicklungsfahrplan extends
    React.Component<ZusatztoolsEntwicklungsfahrplanProps, ZusatztoolsEntwicklungsfahrplanState> {

    constructor(props: any) {
        super(props);

        const modus_entwicklungsfahrplan = this.props.data[IDs.ENT_KONFIGURATION].length > 0
            ? this.props.data[IDs.ENT_KONFIGURATION][0].modus_entwicklungsfahrplan
            : 0;

        this.state = {
            loading: false,
            modus: modus_entwicklungsfahrplan || 0,
            pdfLink: null,
            spalten_anzahl: 3,
            spalten_auswahl: 0,
            spalten_daten: [],
            tid_loaded: 0,
            stand: null
        };
        this.load = this.load.bind(this);
        this.save = this.save.bind(this);
        this.onChangeModus = this.onChangeModus.bind(this);
    }

    private default_h = 700;
    private default_w = 1100;
    private intervalHandle = -1;
    private saveDelay = 3000;
    private saveHandle = -1;

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(DataService) private dataService: DataService;
    @lazyInject(GetLayoutStyle) private getLayoutStyle: GetLayoutStyle;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    componentDidMount(): void {
        this.load();
        this.intervalHandle = window.setInterval(() => {
            // console.log('M: ' + this.state.modus);
            if (+this.state.modus === 1) {
                this.load();
            }
        }, 2000);
    }

    componentDidUpdate(): void {
        if (typeof this.props.setJSXdirect === 'function') {
            this.createDiagrammSvg();
        }
    }

    componentWillUnmount(): void {
        window.clearInterval(this.intervalHandle);
    }

    async createDiagrammSvg(): Promise<void> {
        const graph: HTMLElement = document.getElementById('Entwicklungsplan_SVG');

        if (graph) {
            const itemData = graph.getBoundingClientRect();
            const svg = new XMLSerializer().serializeToString(graph);
            // const svgBlob = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml;charset=utf-8' }));
            // image/svg+xml;charset=utf-8 geht nicht bei Safari
            // image/svg+xml -> der richtiger Typ
            const svgBlob = URL.createObjectURL(new Blob([svg], { type: 'image/svg+xml' }));
            const pngLink = await svgToPng(svgBlob, itemData.width, itemData.height, 3);
            const diagramSize: any = { width: itemData.width, height: itemData.height };
            this.generatePDF(pngLink, diagramSize);
        }
    }

    async generatePDF(pngLink: any, diagramSize: any): Promise<void> {
        const styles: any = this.getLayoutStyle.styles();
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name || '';
        const pdfData: JSX.Element = getPdfData(
            pngLink, diagramSize, this.state.stand, unternehmen, this.contextService, styles,
            typeof this.props.callbackPages === 'function' ? this.props.callbackPages : null
        );

        if (typeof this.props.setJSXdirect === 'function') {
            this.props.setJSXdirect(pdfData);
            return;
        }

        try {
            const blob = await pdf(<Document>{pdfData}</Document>).toBlob();
            const pdfLink: string = URL.createObjectURL(blob);
            this.setState({ loading: false });
            const filename: string = `Entwicklungsplan (Stand ${Moment().format('DD.MM.YYYY')}).pdf`;
            // const a = document.createElement('a');
            // a.title = filename;
            // a.href = pdfLink;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfLink, filename);
        } catch (error) {
            // console.log('error: ', error);
            this.setState({ loading: false });
        }
    }

    load(): void {
        this.dataService.loadData(IDs.ENT_MASSNAHMEN, {}, {}, (result: any, entityName: string, type: string) => {
            const data: any = ((result || {})[IDs.ENT_MASSNAHMEN] || [])[0] || {};

            if (!Object.keys(data).length) {
                return;
            }
            const item: any = JSON.parse(data.daten) || {};
            this.setState({
                stand: data.stamp,
                spalten_anzahl: item.anzahl,
                // spalten_auswahl: item.auswahl,
                spalten_daten: item.daten,
                tid_loaded: data.tid
            }/*, () => console.log('STATE', this.state)*/);
        }, IDs.MOD_ETOOL);
    }

    onChangeModus(value: number): void {
        const tid: number = ((this.props.data[IDs.ENT_KONFIGURATION] || [])[0] || {}).tid || null;

        if (!tid) {
            return;
        }
        const item: any = { tid, modus_entwicklungsfahrplan: value };
        this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_KONFIGURATION, item, () => {
            this.triggerService.fire('reload', IDs.ENT_KONFIGURATION);
        });
    }

    render(): JSX.Element {
        const { stand, modus } = this.state;
        const bsp = require('../../img/bsp_Betriebsentwicklungsfahrplan.png');
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name || '';

        if (typeof this.props.setJSXdirect === 'function') {
            return this.renderPlan();
        }

        return (
            <div
                style={{
                    textAlign: 'left', padding: '20px 0', display: 'flex', flexDirection: 'column', flex: 1, minHeight: 0,
                    overflowY: 'auto'
                }}
            >
                {modus > 0 && this.renderTitle()}
                <div style={{ display: 'flex', fontSize: 26, fontWeight: 'bold', color: '#555', marginTop: 20, paddingLeft: 20 }}>
                    {i18n('Individueller Betriebsentwicklungsfahrplan', 'sys')}
                </div>
                {modus
                    ? <div
                        style={{
                            fontSize: 20, fontWeight: 'bold', color:'var(--color-section-main, #84b0d6)', marginTop: 10, paddingLeft: 20,
                            display: 'flex'
                        }}
                    >
                        {unternehmen}
                    </div>
                    : <div />
                }
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                    {!modus
                        ? <div style={{ width: 1140, height: 700, marginTop: 40 }}>
                            <img alt='bsp_Betriebsentwicklungsfahrplan.png' src={bsp} />
                        </div>
                        : <div>
                            {this.renderPlan()}
                            <div style={{ fontSize: 14, color: '#555', marginTop: 5, marginLeft: 20 }}>
                                {i18n('Stand', 'sys')}: {stand > 0 ? Moment.unix(stand / 1000).format('DD.MM.YYYY') : ''}
                            </div>
                        </div>
                    }
                    {this.renderControls()}
                </div>
                {this.state.loading && <WSpinner label='PDF ...' />}
            </div>
        );
    }

    renderControls(): JSX.Element {
        return (
            <div
                className={formStyle.formCompact}
                style={{
                    marginTop: (+this.state.modus !== 2 ? 32 : 8), marginLeft: 30, padding: 10, backgroundColor: '#ddd', borderRadius: 20,
                    fontSize: '14px', height: 'fit-content', maxHeight: +this.state.modus !== 2 && 647
                }}
            >
                <span
                    style={{
                        display: 'inline-block', width: 420, backgroundColor: '#aaa', color: '#fff', padding: 3, marginTop: 10,
                        marginBottom: 10, borderRadius: 5
                    }}
                >
                    {i18n('Allgemein', 'sys')}
                </span>
                {this.renderModeSelect()}
                {+this.state.modus === 2 &&
                    <>
                        <span
                            style={{
                                display: 'inline-block', width: 420, backgroundColor: '#aaa', color: '#fff', padding: 3, marginTop: 10,
                                marginBottom: 10, borderRadius: 5
                            }}
                        >
                            {i18n('Spalten-Konfiguration', 'sys')}
                        </span>
                        <br />
                        <span style={{ display: 'inline-block', width: 200 }}>{i18n('Anzahl Spalten', 'sys')}:</span>
                        <input
                            style={{ fontSize: 11, width: 200, boxSizing: 'border-box' }}
                            type='number'
                            min={3}
                            max={6}
                            value={this.state.spalten_anzahl}
                            onChange={(evt: any) => {
                                const anz = evt.target.value;
                                this.setState({ spalten_anzahl: anz });

                                if (this.state.spalten_auswahl > anz - 1) {
                                    this.setState({ spalten_auswahl: anz - 1 });
                                }
                            }}
                        />
                        {this.renderSpaltenSelect()}
                        <span
                            style={{
                                display: 'inline-block', width: 420, backgroundColor: '#aaa', color: '#fff', padding: 3, marginTop: 10,
                                marginBottom: 10, borderRadius: 5
                            }}
                        >
                            {i18n('Spalten-Inhalt', 'sys')}
                        </span>
                        {this.renderSpaltenEditor()}
                    </>
                }
                {!this.state.modus &&
                    <div style={{ marginTop: 40, textAlign: 'justify', boxSizing: 'border-box', maxWidth: 420 }}>
                        {renderText('Entwicklungsfahrplan_Beispiel', this.props.data)}
                        <div>
                            {i18n('Eine detaillierte Anleitung zur Arbeit mit dem Instrument haben wir Ihnen zudem hier hinterlegt', 'sys')}:
                            &nbsp;{this.renderIbefLink()}
                        </div>
                    </div>
                }
            </div>
        );
    }

    renderIbefLink(): JSX.Element {
        const id: number = ((this.props.data[IDs.ENT_DATEIEN] || [])
            .find((item: any) => (item.kennung || null) === 'entwicklungsfahrplan_ibef') || {}).datei || null;

        return (
            <div style={{ display: 'inline-block' }}>
                <WArchivIcon
                    module={IDs.MOD_ETOOL_ADMIN}
                    archivId={id}
                    hideIcon
                    hideFilename
                    title={<span style={{ textDecoration: 'underline', color: '#6692c3', cursor: 'pointer' }}>{i18n('iBEF-Hilfe', 'sys')}</span>}
                    iconSize={24}
                />
            </div>
        );
    }

    renderLabels(): JSX.Element {
        // const y_ekz_label = this.default_h * 0.6 + 45 + ((this.state.spalten_anzahl - 3) * 15);
        const y_ekz_label = this.default_h * 0.6 + 45 + ((this.state.spalten_anzahl - 3) * 15) - 25;
        const x_ekz_label = 10;
        const a_ekz_label = - this.state.spalten_anzahl * 0.75;

        const daten = this.state.spalten_daten;
        const firstCol = daten.length > 0 ? daten[0] : {};
        const kennzahlen = this.props.data[IDs.ENT_KENNZAHLEN_DEFINTION];
        const ekzKuerzel = firstCol && firstCol.ekzKuerzel ? firstCol.ekzKuerzel : null;
        const showEkz = firstCol && firstCol.showEkz === 'nein' ? false : true;
        const ekzFnd = kennzahlen.find((k: any) => k.kuerzel === ekzKuerzel);
        const ekzTitel = ekzFnd ? ekzFnd.name : '';

        return (
            <g>
                <text
                    transform={`translate(${x_ekz_label}, ${y_ekz_label}) rotate(${a_ekz_label})`}
                    style={{ fill: '#ffffff' }}
                    // textRendering='optimizeLegibility'
                    textRendering='geometricPrecision'
                >
                    {showEkz &&
                        <tspan style={{ fontSize: '0.9em', fontWeight: 'bold' }}>
                            EKZ: {ekzTitel}
                        </tspan>
                    }
                    <tspan x={this.default_w - 310} style={{ fontSize: '1.2em', fontWeight: 'bold' }}>
                        {'Energieeffizienz & Klimaschutz'}
                    </tspan>
                </text>
            </g>
        );
    }

    renderModeSelect(): JSX.Element {
        return (
            <div>
                <span style={{ display: 'inline-block', width: 200 }}>{i18n('Anzeige-Modus', 'sys')}</span>
                <select
                    style={{ fontSize: 11 }}
                    onChange={(evt: any) => {
                        this.setState({ modus: +evt.target.value });
                        this.onChangeModus(evt.target.value);
                    }}
                    value={+this.state.modus}
                >
                    <option value={0}>{i18n('Beispiel', 'sys')}</option>
                    <option value={2}>{i18n('Berater:in', 'sys')}</option>
                </select>
            </div>
        );
    }

    renderPlan(): JSX.Element {
        const width = this.default_w;
        const height = this.default_h;
        const spalten_anz = this.state.spalten_anzahl;

        const daten = this.state.spalten_daten;
        const firstCol = daten.length > 0 ? daten[0] : {};
        const showEkz = firstCol && firstCol.showEkz === 'nein' ? false : true;

        const spalten: JSX.Element[] = [];

        for (let i = 0; i < spalten_anz; i++) {
            spalten.push(
                <React.Fragment key={`spalte-${i}`}>
                    <EntwicklungsplanSpalte
                        data={this.props.data}
                        width_total={width}
                        height_total={height}
                        columns_total={spalten_anz}
                        column_position={i}
                        shifting={15}
                        spalten_daten={daten}
                        spalt_idx={i}
                        showEkz={showEkz}
                        onSelect={(id: number) => this.setState({ spalten_auswahl: id })}
                    />
                </React.Fragment>
            );
        }

        for (let i = 0; i < spalten_anz; i++) {
            spalten.push(
                <React.Fragment key={`spalte2-${i}`}>
                    <EntwicklungsplanSpalteMass2
                        width_total={width}
                        height_total={height}
                        columns_total={spalten_anz}
                        column_position={i}
                        shifting={15}
                        spalten_daten={daten}
                        spalt_idx={i}
                        onSelect={(id: number) => this.setState({ spalten_auswahl: id })}
                    />
                </React.Fragment>
            );
        }

        return (
            <svg
                id='Entwicklungsplan_SVG'
                viewBox={`0 0 ${width} ${height}`}
                // Firefox does not support drawing SVG images to canvas unless the svg file has width/height attributes
                // on the root <svg> element and those width/height attributes are not percentages.
                // style={{ width: `${width}px`, height: `${height}px` }}
                width={width + 40}
                height={height}
                // Für SVG to PNG, Font und Font-Family beibehalten
                fontSize={16}
                fontFamily={'Arial, sans-serif'}
                // WAEW-218: Oberen Rand optimieren
                style={{ backgroundColor: 'white' }}
            >
                {/* <text y={40} style={{ fontSize: 26, fontWeight: 'bold', fill: '#555' }}>
                    Individueller Betriebsentwicklungsfahrplan
                </text> */}
                {spalten}
                {this.renderLabels()}
            </svg>
        );
    }

    renderSpaltenEditor(): JSX.Element {
        const { spalten_daten, spalten_auswahl } = this.state;

        return (
            <ZusatztoolsEntwicklungsfahrplanSpaltenEditor
                data={this.props.data}
                spalten_auswahl={spalten_auswahl}
                spalten_data_all={{ ...spalten_daten }}
                onSpaltenDataChange={(num: number, data: any) => {
                    spalten_daten[num] = data;
                    this.setState({ spalten_daten }, () => this.save());
                }}
            />
        );
    }

    renderSpaltenSelect(): JSX.Element {
        const options: JSX.Element[] = [];
        const spalten_anz = this.state.spalten_anzahl;

        for (let i = 0; i < spalten_anz; i++) {
            options.push(
                <option
                    key={`spalte_select-${i}`}
                    value={i}
                >
                    {i18n('Spalte', 'sys')} {i + 1}
                    {this.state.spalten_daten[i] && this.state.spalten_daten[i].name &&
                        ' - ' + this.state.spalten_daten[i].name
                    }
                </option>
            );
        }
        return (
            <div style={{ marginTop: 5 }}>
                <span style={{ display: 'inline-block', width: 200 }}>{i18n('Auswahl Spalte', 'sys')}:</span>
                <select
                    style={{ fontSize: 11, width: 200 }}
                    onChange={(evt: any) => this.setState({ spalten_auswahl: evt.target.value })}
                    value={this.state.spalten_auswahl}
                >
                    {options}
                </select>
            </div>
        );
    }

    renderTitle(): JSX.Element {
        return (
            <div className={style.titleWrapper} style={{ marginLeft: 20 }}>
                <WActionButton
                    label={i18n('PDF generieren', 'sys')}
                    insideText={i18n('PDF generieren', 'sys')}
                    key='pdf'
                    action='pdf'
                    onAction={() => this.setState({ loading: true }, this.createDiagrammSvg)}
                />
            </div>
        );
    }

    save(): void {
        const saveHandle = window.setTimeout(() => {
            if (this.saveHandle !== saveHandle) {
                return;
            }
            const dataToSave = {
                anzahl: this.state.spalten_anzahl,
                auswahl: this.state.spalten_auswahl,
                daten: this.state.spalten_daten
            };
            const json = JSON.stringify(dataToSave);
            const stand = new Date().getTime();
            const item = {
                tid: this.state.tid_loaded,
                version: 0,
                daten: json,
                stamp: stand
            };
            this.setState({ stand });
            console.log('Save ...', item);
            this.dataService.setData(IDs.MOD_ETOOL, IDs.ENT_MASSNAHMEN, item, (insertID: number) => {
                if (this.state.tid_loaded === 0) {
                    this.load();
                }
            });
        }, this.saveDelay);
        this.saveHandle = saveHandle;
    }
}
